import axiosIns from '@/libs/axios'

const ROOT_URL = '/api-keys'

export default {
  namespaced: true,
  state: {
    dataList: [],
    providers: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    dataSave: { message: null, status: null },
  },
  getters: {
    dataList: s => s.dataList,
    providers: s => s.providers,
    metaData: s => s.metaData,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_PROVIDERS(state, data) { state.providers = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'API anahtar listesi alınamadı.' })
        })
    },
    getProviders({ commit }) {
      return axiosIns.get(`${ROOT_URL}/providers`)
        .then(response => commit('SET_PROVIDERS', response.data.data))
        .catch(error => { console.error(error); commit('SET_PROVIDERS', []) })
    },
    create({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/create`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'API anahtarı eklendi.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Ekleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    update({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'API anahtarı güncellendi.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    remove({ commit, dispatch }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'API anahtarı silindi.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Silme başarısız.' })
        })
    },
    testConnection({ commit }, { id, market = 'FUTURES' }) {
      return axiosIns.post(`${ROOT_URL}/${id}/test`, { market })
        .then(response => {
          const data = response.data.data || {}
          commit('SET_DATA_SAVE', {
            status: true,
            message: `Bağlantı OK · ${data.sampleAssetCount ?? 0} asset görünüyor`,
          })
          return data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Bağlantı testi başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
  },
}
